import React, { useEffect, useState } from 'react'
import { My } from '../components/My'

import { isMobile } from 'react-device-detect'

import useConfirmPayment from '../hooks/query/useConfirmPayment'
import useGetMePlan from '../hooks/query/useGetMePlan'

import { useNavigate } from 'react-router-dom'

import { Spinner } from '../components/atom/Spinner'
import useGetMe from '../hooks/query/useGetMe'

import {
  getUtmLocalStorage,
  handlPlanName,
  showErrorBox,
  transitionPlanName,
  UserType,
} from '../utils/common'
import classNames from 'classnames'

import { PromotionCircle } from '../components/upgrade/PromotionCircle'
import { planPurchaseBtnClick } from '../utils/metaAd'
import { useSaveUtm } from '../hooks/query/useSaveUtm'
import {
  EmptyPlan,
  FreePlan,
  LightPlan,
  ProAndPremiumPlanAnnual,
  ProAndPremiumPlanMonthly,
} from '../components/PlanDashBoard/PlanDashBoard'
import { PlanPriceModal } from '../components/payment/PlanPriceModal'
import { PlanTag } from '../components/planTag'
import { subscriptionType } from '../service/plans'
import { Me } from '../service/user'
import useGetUserSubscriptionInfo from '../hooks/query/useGetUserSubscriptionInfo'
import useUserStore from '../store/useUserStore'
import { AuthGuard } from 'components/gaurd/AuthGuard'
import { FastclickDashBoard } from 'components/fastclick/FastclickDashBoard'
import { Helmet } from 'react-helmet-async'
import { PriceGuide } from './price-guide/PriceGuide'

export const MyPayments = () => {
  const navigate = useNavigate()
  const { mutate: saveUtmMutate } = useSaveUtm()
  const { data: userPlanInfo, refetch } = useGetMePlan()
  const { data: userSubscriptionInfo } = useGetUserSubscriptionInfo()
  const { refetch: meRefetch } = useGetMe()
  const userInfo: Me = useUserStore((state: any) => state.userInfo)
  const urlParams = new URLSearchParams(window.location.search)
  const paymentKey = urlParams.get('paymentKey')
  const orderId = urlParams.get('orderId')
  const amount = urlParams.get('amount')
  const [isPlanPriceModal, setPlanPriceModal] = useState<boolean>(false)
  const { mutate: confirmPaymentMutate, isPending } = useConfirmPayment()
  const chartElByTab = () => {
    return (
      <>
        {userInfo?.userType === UserType.라이트 && (
          <>
            <LightPlan
              subscriptionType={
                userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
              }
              startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
              endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
              currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
              subscriptions={userPlanInfo?.subscriptions}
              monthStart={userPlanInfo?.subscriptions.monthStart ?? '--'}
              monthEnd={userPlanInfo?.subscriptions.monthEnd ?? '--'}
            />
          </>
        )}
        {(userInfo?.userType === UserType.프로 ||
          userInfo?.userType === UserType.프리미엄) &&
        userInfo?.subscriptions?.subscriptionType === 'annual' ? (
          <>
            <ProAndPremiumPlanAnnual
              userType={userInfo?.userType}
              subscriptionType={
                userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
              }
              startDate={userPlanInfo?.subscriptions?.monthStart ?? '--'}
              endDate={userPlanInfo?.subscriptions?.monthEnd ?? '--'}
              currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
              available={userPlanInfo?.usage?.available ?? false}
              couponBenefit={userInfo?.couponBenefit}
              isDone={userPlanInfo?.usage?.isDone}
              subscriptions={userPlanInfo?.subscriptions}
            />
          </>
        ) : (
          (userInfo?.userType === UserType.프로 ||
            userInfo?.userType === UserType.프리미엄) &&
          userInfo?.subscriptions?.subscriptionType === 'monthly' && (
            <>
              {' '}
              <ProAndPremiumPlanMonthly
                userType={userInfo?.userType}
                subscriptionType={
                  userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
                }
                startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
                endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
                currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
                totalLimit={userPlanInfo?.usage?.totalLimit ?? 0}
                usedCount={userPlanInfo?.usage?.usedCount ?? 0}
                available={userPlanInfo?.usage?.available ?? false}
                isDone={userPlanInfo?.usage?.isDone}
                couponBenefit={userInfo?.couponBenefit}
                subscriptions={userPlanInfo?.subscriptions}
              />
            </>
          )
        )}
        {userInfo?.userType === UserType.USER && (
          <>
            <EmptyPlan
              subscriptionType={
                userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
              }
              startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
              endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
              currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
              setPlanPriceModal={setPlanPriceModal}
            />
          </>
        )}
        {userInfo?.userType === UserType.체험 && (
          <>
            <FreePlan
              userType={userInfo?.userType}
              subscriptionType={
                userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
              }
              startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
              endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
              currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
              totalLimit={userPlanInfo?.usage?.totalLimit ?? 0}
              usedCount={userPlanInfo?.usage?.usedCount ?? 0}
              available={userPlanInfo?.usage?.available ?? false}
              couponBenefit={userInfo?.couponBenefit}
              isDone={userPlanInfo?.usage?.isDone}
              subscriptions={userPlanInfo?.subscriptions}
            />
          </>
        )}
      </>
    )
  }

  const selectImgColor = (planName: string) => {
    if (planName === '체험' || planName === '숏폼 스페셜') {
      return 'assets/img/check_circle_blue.png'
    }
    return 'assets/img/check_circle.png'
  }
  const handleDate = () => {
    if (userInfo?.subscriptions?.subscriptionType === subscriptionType.ANNUAL) {
      return (
        <>
          <p>
            기간 : {userPlanInfo?.subscriptions?.startDate ?? '--'} ~{' '}
            {userPlanInfo?.subscriptions?.endDate ?? '--'}
          </p>
        </>
      )
    } else if (
      userInfo?.subscriptions?.subscriptionType === subscriptionType.MONTHLY
    ) {
      return (
        <>
          <p>
            기간 : {userPlanInfo?.subscriptions?.startDate ?? '--'} ~{' '}
            {userPlanInfo?.subscriptions?.endDate ?? '--'}
          </p>
        </>
      )
    } else {
      return (
        <>
          <p>기간 : - ~ -</p>
        </>
      )
    }
  }

  useEffect(() => {
    if (paymentKey && orderId && amount) {
      const confirmPaymentParams = {
        paymentKey,
        orderId,
        amount: Number(amount),
      }
      confirmPaymentMutate(confirmPaymentParams, {
        onSuccess: (data) => {
          const utmData = getUtmLocalStorage()
          if (utmData?.utmSource) {
            utmData.trackType = 'PURCHASE_PLAN'
            saveUtmMutate(utmData, {
              onSuccess: () => {},
              onError: () => {},
            })
          } else {
            planPurchaseBtnClick()
          }

          navigate('/my-payments')
        },
        onError: () => {
          navigate('/payment-fail?path=price-guide&type=plan')
        },
      })
    }
  }, [paymentKey, orderId, amount])

  useEffect(() => {
    if (isPending) {
      document.body.classList.add('overflow-hidden') // Tailwind 유틸리티 클래스 사용
    } else {
      document.body.classList.remove('overflow-hidden')
      meRefetch()
      refetch()
    }
  }, [isPending])

  return (
    <>
      <Helmet>
        <title>내 플랜</title>
        <meta
          name="description"
          content="현재 사용 중인 상품 영상 플랜 정보 확인 & 관리"
        />
        <link
          rel="canonical"
          href="https://fastcut.fastseller.shop/my-payments"
        />
      </Helmet>
      <div className="md:min-y-[100vh] relative mx-auto my-0 flex max-w-[375px] flex-col px-[16px] md:max-w-[816px]">
        <div className="w-[343px] md:w-full">
          <div className="flex flex-col gap-3">
            <My>
              <p>내 플랜</p>
            </My>
            <div className="mt-6 flex justify-center">
              <p className="text-[24px] font-bold md:text-[40px]">내 플랜</p>
            </div>

            <div className="flex flex-col gap-1">
              <div className="flex justify-between gap-1">
                <div className="flex gap-1 font-bold">
                  <p>{handlPlanName(userInfo, userSubscriptionInfo)}</p>

                  <PlanTag
                    planName={
                      transitionPlanName[
                        userPlanInfo?.subscriptions
                          ?.planName as keyof typeof transitionPlanName
                      ]
                    }
                    className=""
                  />
                </div>
                {userInfo?.billing?.connected &&
                  userInfo?.userType !== UserType.USER &&
                  userInfo?.userType !== UserType.체험 && (
                    <button
                      className="text-[14px] text-[#8F929B] underline"
                      onClick={() => {
                        navigate('/subscription?page=1&pageSize=10')
                      }}
                    >
                      관리
                    </button>
                  )}{' '}
              </div>
              <div className="name">
                {userInfo?.userInfo?.name}
                {` `}({userInfo?.userInfo?.email}){` `}님
              </div>
              {handleDate()}
              <div className="usage">
                현황 : <span>요청 {userInfo?.usage?.usedCount}개</span> /
                <span>최대 {userInfo?.usage?.totalLimit}개</span>
              </div>
            </div>

            {userInfo?.userType === UserType['숏폼 스페셜'] && (
              <div className="flex w-full flex-col items-center gap-4 md:flex-row">
                <button
                  className="h-[34px] w-full rounded-[10px] bg-href text-[14px] font-bold text-white"
                  onClick={() => {
                    navigate('/video-editor')
                  }}
                >
                  상품 숏폼 만들기
                </button>
                {/* 월결제인원들에게 40%로 할인하는 프로모션 버튼  */}
                <PromotionCircle userInfo={userInfo} />
              </div>
            )}
            {userInfo?.userType !== UserType['숏폼 스페셜'] && (
              <div className="flex w-full flex-col items-center gap-4 md:flex-row">
                <button
                  className="h-[34px] w-full rounded-[10px] bg-main text-[14px] font-bold text-white"
                  onClick={() => {
                    navigate('/video-editor')
                  }}
                >
                  상품 영상 만들러 가기
                </button>
                <PromotionCircle userInfo={userInfo} />
              </div>
            )}
          </div>
          <AuthGuard userInfo={userInfo}>
            <FastclickDashBoard
              userInfo={userInfo}
              blockPadding="px-0"
              blockWidth="w-full"
            />
          </AuthGuard>
          {userPlanInfo?.subscriptions ? (
            <>
              <div
                className={classNames(
                  'mt-[32px] rounded-[20px] border-[2px] p-[32px]',
                  {
                    'border-main bg-[#E9F8F9]':
                      userPlanInfo?.subscriptions.planName !== '체험' &&
                      userPlanInfo?.subscriptions.planName !== '숏폼 스페셜',
                    'border-href bg-[#E9EDF9]':
                      userPlanInfo?.subscriptions.planName === '체험' ||
                      userPlanInfo?.subscriptions.planName === '숏폼 스페셜',
                  },
                )}
              >
                <div className="flex flex-col items-center justify-center gap-[12px]">
                  <p
                    className={classNames('text-[24px] font-bold', {
                      'text-main':
                        userPlanInfo?.subscriptions.planName !== '체험' &&
                        userPlanInfo?.subscriptions.planName !== '숏폼 스페셜',
                      'text-href':
                        userPlanInfo?.subscriptions.planName === '체험' ||
                        userPlanInfo?.subscriptions.planName === '숏폼 스페셜',
                    })}
                  >
                    {userPlanInfo?.subscriptions.planName === '체험'
                      ? '체험하기'
                      : `${userPlanInfo?.subscriptions.planName} 플랜`}
                  </p>
                  {/* <p>
                  <span className="font-bold text-[32px]">
                    {userPlanInfo?.planPrice?.planPrice?.length
                      ? userPlanInfo?.planPrice?.planPrice[0]?.price.toLocaleString() +
                        '원'
                      : '0원'}
                  </span>
                  {!!userPlanInfo?.planPrice.planPrice[0] &&
                  userPlanInfo?.planPrice?.planPrice[0] &&
                  userPlanInfo?.planPrice?.planPrice[0]?.subscriptionType ===
                    'monthly' ? (
                    <span className="text-[18px]">/월(VAT 별도)</span>
                  ) : (
                    <span className="text-[18px]">/1년(VAT 별도)</span>
                  )}
                </p> */}
                </div>

                <div className="mt-[32px] flex">
                  {isMobile ? (
                    <>
                      <div className="flex w-full flex-col gap-[24px]">
                        {userInfo?.userType !== UserType.체험 && (
                          <p className="flex items-center gap-[5px] text-[18px] font-bold">
                            <img
                              src={
                                userPlanInfo?.subscriptions.planName !== '체험'
                                  ? 'assets/img/check_circle.png'
                                  : 'assets/img/check_circle_blue.png'
                              }
                              alt="check_circle"
                              width={24}
                              height={24}
                            />
                            {userInfo?.subscriptions?.subscriptionType ===
                            'annual' ? (
                              <>12개월 사용</>
                            ) : (
                              <>1개월 사용</>
                            )}
                          </p>
                        )}

                        {userPlanInfo?.planDetail.planDetail.map(
                          (el, index) => {
                            return (
                              <>
                                {el.type === 'feature' && (
                                  <p
                                    className="flex items-center gap-[5px] text-[18px] font-bold"
                                    key={index}
                                  >
                                    <img
                                      src={
                                        userPlanInfo?.subscriptions.planName !==
                                        '체험'
                                          ? 'assets/img/check_circle.png'
                                          : 'assets/img/check_circle_blue.png'
                                      }
                                      alt="check_circle"
                                      width={24}
                                      height={24}
                                    />
                                    {el.name}
                                  </p>
                                )}
                              </>
                            )
                          },
                        )}
                        {userPlanInfo?.planDetail.planDetail.map(
                          (el, index) => {
                            return (
                              <>
                                {el.type === 'function' && (
                                  <p
                                    className="flex items-center gap-[5px] text-[18px] font-bold"
                                    key={index}
                                  >
                                    <img
                                      src={selectImgColor(
                                        userPlanInfo?.subscriptions.planName,
                                      )}
                                      alt="check_circle"
                                      width={24}
                                      height={24}
                                    />
                                    {el.name}
                                  </p>
                                )}
                              </>
                            )
                          },
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex w-[50%] flex-col gap-[24px]">
                        {userInfo?.userType !== UserType.체험 && (
                          <p className="flex items-center gap-[5px] text-[18px] font-bold">
                            <img
                              src={selectImgColor(
                                userPlanInfo?.subscriptions.planName,
                              )}
                              alt="check_circle"
                              width={24}
                              height={24}
                            />
                            {userInfo?.subscriptions?.subscriptionType ===
                            'annual' ? (
                              <>12개월 사용</>
                            ) : (
                              <>1개월 사용</>
                            )}
                          </p>
                        )}
                        {userPlanInfo?.planDetail.planDetail.map(
                          (el, index) => {
                            return (
                              <>
                                {el.type === 'feature' && (
                                  <p
                                    className="flex items-center gap-[5px] text-[18px] font-bold"
                                    key={index}
                                  >
                                    <img
                                      src={selectImgColor(
                                        userPlanInfo?.subscriptions.planName,
                                      )}
                                      alt="check_circle"
                                      width={24}
                                      height={24}
                                    />
                                    {el.name}
                                  </p>
                                )}
                              </>
                            )
                          },
                        )}
                      </div>
                      <div className="flex w-[50%] flex-col gap-[24px]">
                        {userPlanInfo?.planDetail.planDetail.map(
                          (el, index) => {
                            return (
                              <>
                                {el.type === 'function' && (
                                  <p
                                    className="flex items-center gap-[5px] text-[18px] font-bold"
                                    key={index}
                                  >
                                    <img
                                      src={selectImgColor(
                                        userPlanInfo?.subscriptions.planName,
                                      )}
                                      alt="check_circle"
                                      width={24}
                                      height={24}
                                    />
                                    {el.name}
                                  </p>
                                )}
                              </>
                            )
                          },
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          ) : (
            <PriceGuide />
          )}

          {/* 분기에 따라서 보여줘야할 화면이 달라짐 */}
        </div>
        {isPending && (
          <>
            {' '}
            <Spinner />
          </>
        )}{' '}
        {isPlanPriceModal && (
          <PlanPriceModal
            isPlanPriceModal={isPlanPriceModal}
            setPlanPriceModal={setPlanPriceModal}
            userInfo={userInfo}
          />
        )}
      </div>
    </>
  )
}
